import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Text } from '../Text';

interface IArticleThumb {
  className?: string;
  list: string[];
}

export const StyledSlidingText = styled.div`
  height: ${rem(`68px`)};
  overflow: hidden;
  ${(props) => props.theme.breakpoints.phone`
    height: ${rem(`76px`)};
  `}
  ${(props) => props.theme.breakpoints.desktop`
    margin-bottom: ${rem(`12px`)};
  `}
  .sliding-text-animation {
    display: flex;
    flex-direction: column;
    animation: sliding-text 10s cubic-bezier(0.83, 0, 0.17, 1) infinite;
    background-image: ${({ theme }) => theme.gradiants.orange_1};
    background-clip: text;
    margin: 0;
    padding: 0;
    list-style: none;
    &__item {
      flex: 1 0 auto;
      display: flex;
    }
    &__text {
      color: transparent;
      flex: 1 0 auto;
      font-size: 3rem;
      line-height: ${rem(`56px`)};
      margin-bottom: ${rem(`12px`)};
      ${(props) => props.theme.breakpoints.phone`
        font-size: 4rem;
        line-height: ${rem(`64px`)};
      `}
    }
  }
  @keyframes sliding-text {
    0%,
    20% {
      transform: translateY(0);
    }
    25%,
    45% {
      transform: translateY(-20%);
    }
    50%,
    70% {
      transform: translateY(-40%);
    }
    75%,
    95% {
      transform: translateY(-60%);
    }
    100% {
      transform: translateY(-80%);
    }
  }
`;

export const SlidingText = ({ className, list }: IArticleThumb) => {
  return (
    <StyledSlidingText className={className}>
      <ul className="sliding-text-animation">
        {list.map((item) => (
          <li className="sliding-text-animation__item" key={item}>
            <Text
              type="title1"
              tag="div"
              noRhythem
              className="sliding-text-animation__text"
            >
              {item}
            </Text>
          </li>
        ))}
        <li className="sliding-text-animation__item" aria-hidden>
          <Text
            type="title1"
            tag="div"
            noRhythem
            className="sliding-text-animation__text"
          >
            {list[0]}
          </Text>
        </li>
      </ul>
    </StyledSlidingText>
  );
};
